import { useState, type FormEvent } from "react";
import { useAuth } from "../auth";
import { api, ApiError } from "../api";

/** User profile page in Settings — read-only identity + inline
 *  change-password form. Change-password also still accessible from
 *  sidebar footer (shortcut); keeping both entry points is cheap. */
export function ProfilePage() {
  const { user, logout } = useAuth();
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null); setSuccess(false);
    if (newPw !== confirmPw) return setError("Xác nhận mật khẩu không khớp");
    if (newPw.length < 8) return setError("Mật khẩu mới phải từ 8 ký tự");
    setSubmitting(true);
    try {
      await api.post("/auth/me/change-password", {
        current_password: currentPw, new_password: newPw,
      });
      setSuccess(true);
      setCurrentPw(""); setNewPw(""); setConfirmPw("");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Đổi mật khẩu thất bại");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <div className="card">
        <h3 style={{ marginTop: 0 }}>Thông tin tài khoản</h3>
        <table>
          <tbody>
            <tr><td style={{ width: 150 }}>Email</td><td><strong>{user?.email}</strong></td></tr>
            <tr><td>Role</td><td>
              <span className={`badge ${user?.is_platform_admin ? "admin" : "owner"}`}>
                {user?.is_platform_admin ? "platform admin" : user?.role}
              </span>
            </td></tr>
            <tr><td>Owner ID</td><td className="muted"><code className="inline">{user?.owner_id}</code></td></tr>
            <tr><td>User ID</td><td className="muted"><code className="inline">{user?.id}</code></td></tr>
          </tbody>
        </table>
      </div>

      <div className="card" style={{ marginTop: 16 }}>
        <h3 style={{ marginTop: 0 }}>Đổi mật khẩu</h3>
        <form onSubmit={onSubmit} style={{ maxWidth: 420 }}>
          {error && <div className="alert error">{error}</div>}
          {success && <div className="alert ok">Mật khẩu đã cập nhật.</div>}
          <div className="field">
            <label>Mật khẩu hiện tại</label>
            <input type="password" value={currentPw} onChange={(e) => setCurrentPw(e.target.value)} required autoComplete="current-password" />
          </div>
          <div className="field">
            <label>Mật khẩu mới (min 8)</label>
            <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} required minLength={8} autoComplete="new-password" />
          </div>
          <div className="field">
            <label>Xác nhận</label>
            <input type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} required minLength={8} autoComplete="new-password" />
          </div>
          <button type="submit" className="primary" disabled={submitting}>
            {submitting ? "Đang đổi…" : "Đổi mật khẩu"}
          </button>
        </form>
      </div>

      <div className="card" style={{ marginTop: 16 }}>
        <h3 style={{ marginTop: 0 }}>Đăng xuất</h3>
        <p className="muted" style={{ fontSize: "0.85rem" }}>
          Logout khỏi session này. JWT bị xoá khỏi localStorage; login lại cần email + password.
        </p>
        <button className="danger" onClick={logout}>Đăng xuất</button>
      </div>
    </>
  );
}
